import { render, staticRenderFns } from "./editFertigerOpeningHours.vue?vue&type=template&id=4616804d&scoped=true"
import script from "./editFertigerOpeningHours.vue?vue&type=script&lang=js"
export * from "./editFertigerOpeningHours.vue?vue&type=script&lang=js"
import style0 from "./editFertigerOpeningHours.vue?vue&type=style&index=0&id=4616804d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4616804d",
  null
  
)

export default component.exports